import { InputAttachmentType } from '@/common/components/base/input/base/CommonInput.type.ts';

const createAttachment = ({
  element,
  size = 'medium',
  shouldRender = true,
  height,
}: InputAttachmentType): InputAttachmentType => {
  return {
    element,
    size,
    shouldRender,
    height,
  };
};
export default createAttachment;
